import { render, staticRenderFns } from "./MainContentsAfLogin.vue?vue&type=template&id=1eb2310a"
import script from "./MainContentsAfLogin.vue?vue&type=script&lang=js"
export * from "./MainContentsAfLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1eb2310a')) {
      api.createRecord('1eb2310a', component.options)
    } else {
      api.reload('1eb2310a', component.options)
    }
    module.hot.accept("./MainContentsAfLogin.vue?vue&type=template&id=1eb2310a", function () {
      api.rerender('1eb2310a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/main/MainContentsAfLogin.vue"
export default component.exports